import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useInView } from 'react-intersection-observer';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { VIRTUAL_ROOT_MARGIN } from './TableStore';
import TableCell from './TableCell';
const TableVirtualCell = function TableVirtualCell(props) {
    const { tableStore: { node } } = useContext(TableContext);
    const { ref: intersectionRef, inView, entry } = useInView({
        root: node.tableBodyWrap || node.element,
        rootMargin: `${VIRTUAL_ROOT_MARGIN}px`,
        initialInView: true,
    });
    const height = !inView && entry && entry.target.offsetParent ?
        pxToRem(entry.boundingClientRect.height || entry.target.offsetHeight, true)
        : undefined;
    return (React.createElement(TableCell, Object.assign({}, props, { intersectionRef: intersectionRef, inView: inView, virtualHeight: height })));
};
TableVirtualCell.displayName = 'TableVirtualCell';
export default observer(TableVirtualCell);
